import { H5 } from 'UIComponents/elements/headings';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIPanelSection from 'UIComponents/panel/UIPanelSection';
import UILink from 'UIComponents/link/UILink';
import FormattedMessageWithObjectTypeName from 'automation-ui-i18n/FormattedMessageWithObjectTypeName';
import { datasetPageUrlFromId } from 'automation-ui-enrollment/constants/urls';
import DatasetSelect from 'automation-ui-enrollment/components/enrollment/manual/DatasetSelect';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ManualEnrollmentByDataset = ({
  objectTypeId,
  selectedDatasetId,
  handleDatasetSelect,
  mode
}) => {
  return /*#__PURE__*/_jsxs(UIPanelSection, {
    className: "m-top-10 p-top-0",
    children: [/*#__PURE__*/_jsx(H5, {
      className: "m-bottom-2",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-enrollment.redesign.enrollExistingPanel.enrollFromDataset.selected.title"
      })
    }), mode === 'EXISTING' ? /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
      baseLangKey: "automation-ui-enrollment.redesign.enrollExistingPanel.enrollFromDataset.informationExisting_cob",
      objectTypeId: objectTypeId
    }) : /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
      baseLangKey: "automation-ui-enrollment.redesign.enrollExistingPanel.selected.information_cob",
      objectTypeId: objectTypeId
    }), /*#__PURE__*/_jsx(DatasetSelect, {
      selectedDatasetId: selectedDatasetId,
      onDatasetSelect: selectedDatasetEvent => {
        handleDatasetSelect(selectedDatasetEvent);
      },
      objectTypeId: objectTypeId
    }), selectedDatasetId && /*#__PURE__*/_jsx(View, {
      marginBlockStart: "200",
      as: "div",
      children: /*#__PURE__*/_jsx(UILink, {
        external: true,
        href: datasetPageUrlFromId(selectedDatasetId),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-enrollment.redesign.enrollExistingPanel.enrollFromDataset.selected.viewLink"
        })
      })
    })]
  });
};
export default ManualEnrollmentByDataset;